var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-footer",class:{'top-line': _vm.showTopLine}},[_c('div',{staticClass:"left-container"}),(_vm.showLastUpdate)?_c('LastUpdated',{attrs:{"file":_vm.file}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }